import { useEffect } from 'react';

const useClarity = () => {
    useEffect(() => {
        const updateConsent = () => {
            const categories = window.OptanonActiveGroups;
            const granted = categories?.includes('C0002');

            if (window.clarity) {
                window.clarity('consentv2', {
                    analytics_Storage: granted ? 'granted' : 'denied'
                });
            }
        };

        window.addEventListener('OneTrustGroupsUpdated', updateConsent);
        window.addEventListener('load', updateConsent);

        return () => {
            window.removeEventListener(
                'OneTrustGroupsUpdated',
                updateConsent
            );
            window.removeEventListener('load', updateConsent);
        };
    }, []);
};

export default useClarity;
